import * as React from 'react';
import { FelaComponent } from '@filou/core';
import cloudinary from './cloudinary';
var renderText = function (item, index) {
    if (item === void 0) { item = []; }
    if (index === void 0) { index = 0; }
    if (!item) {
        return null;
    }
    if (item && typeof item === 'string') {
        return React.createElement("p", null, item);
    }
    if (Array.isArray(item)) {
        return item.map(renderText);
    }
    if (Array.isArray(item.text)) {
        return item.text.map(renderText);
    }
    if ((item.type === 'paragraph' || !item.type) && item.text) {
        return React.createElement("p", { key: index }, item.text);
    }
    else if (item.type === 'image') {
        return (React.createElement(FelaComponent, { style: {
                float: 'left',
                width: '200px',
                height: 'auto',
                ifSmallDown: {
                    width: '100%',
                    maxWidth: 200,
                    marginX: 'auto',
                    float: 'initial'
                }
            }, render: function (_a) {
                var className = _a.className;
                return (React.createElement("img", { key: index, className: className, src: cloudinary(item.url, 'w_400') }));
            } }));
    }
    return null;
};
export default renderText;
//# sourceMappingURL=render-text.js.map